/**
 *
 * Used to localized message string coming from the server to human-readable text
 */
export default function () {
  const messagesHash: Map<string, string> = new Map([
    ['email is invalid', 'Geben Sie bitte eine gültige E-Mail-Adresse ein.'],
    ['email exists', 'Ein Benutzer mit dieser E-Mail-Adresse ist bereits registriert.'],
    [
      'gmail is taken',
      'Die Registrierung mit Wegwerf Email-Adressen ist nicht möglich. Bitte verwenden Sie für die Registrierung eine andere Email-Adresse.',
    ],
    [
      'email is throwaway',
      'Die Registrierung mit Wegwerf Email-Adressen ist nicht möglich. Bitte verwenden Sie für die Registrierung eine andere Email-Adresse.',
    ],
    [
      'password is too short or not secure enough',
      'Das Passwort muss mindestens 8 Zeichen lang sein, ein Sonderzeichen,eine Zahl und Groß-/Kleinbuchstaben enthalten.',
    ],
    ['displayname is taken', 'Der Name wird bereits von einem anderen Nutzer verwendet.'],

    ['no content found', 'Inhalt sollte nicht leer sein'],
    ['cannot create thought for this topic', 'Es ist derzeit nicht möglich neue Beiträge zu erstellen.'],
    ['user cannot edit this thought', 'Sie haben keine Berechtigung den Beitrag zu bearbeiten.'],

    ['voting is disabled', 'Abstimmen ist deaktiviert.'],
    ['voting needs login', 'Sie müssen sich erst einloggen, um abzustimmen'],
    ['cannot vote your own thought', 'Die Abstimmung für einen eigenen Beitrag ist nicht vorgesehen.'],
    ['attach_link_url too long', 'Die eingegebene URL ist zu lang. Bitte geben Sie eine kürzere URL an.'],
    [
      'attachment is bigger than allowed size',
      'Ihre Datei überschreitet die maximal zulässige Größe von [_0] für Anhänge. Bitte wählen Sie eine kleinere Datei.',
    ],
  ]);

  /**
   * returns a localized error message from the given server string, or the string itself if the localized message is not found
   * if the localized string has parameters ([_0], [_1], etc.), you can also pass array of string to replace them, based on the index
   * @param key error message from server
   * @param params extra string parameters for localized message
   * @returns the localized error message or the original string if not found
   */
  function l(key: string, params: Array<string> = []): string {
    const value = messagesHash.get(key);
    if (value) {
      params.forEach((p, idx) => {
        value?.replaceAll('[_' + idx + ']', p);
      });
      return value;
    }
    return key;
  }

  return { l };
}
